/* Eliza header: sticky header, search overlay with predictive results, mobile nav drawer,
   plus the product-card swatch sliders. Behaviour follows the live store. */
(function () {
  const html = document.documentElement;

  /* sticky: past 250px the header becomes fixed and slides in (live Impulse behaviour) */
  const header = document.getElementById('SiteHeader');
  const wrap = document.getElementById('StickyHeaderWrap');
  if (header && wrap && header.dataset.sticky === 'true') {
    let stuck = false;
    const setHeight = () => { wrap.style.height = header.offsetHeight + 'px'; };
    if (!stuck) setHeight();
    window.addEventListener('resize', () => { if (!stuck) setHeight(); });
    const update = () => {
      if (window.scrollY > 250) {
        if (stuck) return;
        stuck = true;
        header.classList.add('site-header--stuck');
        setTimeout(() => header.classList.add('site-header--opening'), 100);
      } else {
        if (!stuck) return;
        stuck = false;
        header.classList.remove('site-header--opening', 'site-header--stuck');
      }
    };
    window.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    update();
  }

  /* overlay used by the search and the drawers */
  const openOverlay = (cls) => { html.classList.add('js-drawer-open', cls); };
  const closeOverlay = (cls) => { html.classList.remove('js-drawer-open', cls); };

  /* search */
  const container = document.getElementById('SearchContainer');
  if (container) {
    const input = container.querySelector('.site-header__search-input');
    const results = container.querySelector('[data-results]');
    const open = (e) => {
      e.preventDefault();
      container.classList.add('is-active');
      html.classList.add('el-search-open');
      requestAnimationFrame(() => input.focus());
    };
    const close = () => {
      container.classList.remove('is-active');
      html.classList.remove('el-search-open');
      results.classList.add('hide');
    };
    document.querySelectorAll('.js-search-header').forEach((a) => a.addEventListener('click', open));
    container.querySelector('.js-search-header-close').addEventListener('click', close);
    document.addEventListener('keyup', (e) => { if (e.key === 'Escape') close(); });
    document.addEventListener('click', (e) => {
      if (container.classList.contains('is-active') && !container.contains(e.target) && !e.target.closest('.js-search-header')) close();
    });
    let timer, last = '';
    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(async () => {
        const q = input.value.trim();
        if (q === last) return;
        last = q;
        if (!q) { results.classList.add('hide'); results.innerHTML = ''; return; }
        const url = `${window.routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product,article,page,collection&resources[limit]=4&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor&section_id=el-predictive-search`;
        try {
          const text = await (await fetch(url)).text();
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const inner = doc.querySelector('#shopify-section-el-predictive-search');
          results.innerHTML = inner ? inner.innerHTML : '';
          results.classList.toggle('hide', !results.innerHTML.trim());
          const more = results.querySelector('[data-view-more]');
          if (more) more.addEventListener('click', () => container.querySelector('form').submit());
        } catch (err) { /* keep the overlay usable without results */ }
      }, 300);
    });
  }

  /* mobile nav drawer */
  const nav = document.getElementById('NavDrawer');
  if (nav) {
    const openBtn = document.querySelector('.js-drawer-open-nav');
    const openNav = () => {
      nav.classList.add('drawer--is-open');
      nav.setAttribute('aria-hidden', 'false');
      openBtn && openBtn.setAttribute('aria-expanded', 'true');
      openOverlay('js-drawer-open-left');
      setTimeout(() => nav.classList.add('is-transitioning'), 10);
    };
    const closeNav = () => {
      nav.classList.remove('drawer--is-open', 'is-transitioning');
      nav.setAttribute('aria-hidden', 'true');
      openBtn && openBtn.setAttribute('aria-expanded', 'false');
      closeOverlay('js-drawer-open-left');
    };
    openBtn && openBtn.addEventListener('click', openNav);
    nav.querySelector('.js-drawer-close').addEventListener('click', closeNav);
    document.addEventListener('click', (e) => {
      if (nav.classList.contains('drawer--is-open') && !nav.contains(e.target) && !e.target.closest('.js-drawer-open-nav')) closeNav();
    });
    document.addEventListener('keyup', (e) => { if (e.key === 'Escape') closeNav(); });
  }

  /* product-card swatch sliders (6 per view, 7.8px apart) */
  window.elInitSwatches = function (root) {
    if (!window.Swiper) return;
    (root || document).querySelectorAll('.js-el-swatch-swiper:not(.swiper-initialized)').forEach((el) => {
      new window.Swiper(el, {
        slidesPerView: 6,
        spaceBetween: 7.8,
        navigation: { nextEl: el.querySelector('.swiper-button-next'), prevEl: el.querySelector('.swiper-button-prev') },
      });
    });
  };

  /* colour swatch hover shows that colour's image (collection and search grids, as live) */
  window.elInitSwatchHover = function (root) {
    root.querySelectorAll('.color-swatch--with-image').forEach((swatch) => {
      if (swatch.dataset.hoverBound) return;
      swatch.dataset.hoverBound = '1';
      swatch.addEventListener('mouseenter', () => {
        const el = document.querySelector('.grid-product__color-image--' + swatch.dataset.variantId);
        if (!el) return;
        el.style.backgroundImage = 'url(' + swatch.dataset.variantImage + ')';
        el.classList.add('is-active');
      });
      swatch.addEventListener('mouseleave', () => {
        const el = document.querySelector('.grid-product__color-image--' + swatch.dataset.variantId);
        el && el.classList.remove('is-active');
      });
    });
  };

  /* like lazysizes data-sizes="auto" on live: sizes = rendered width, so the same CDN file is drawn at the same density */
  const autosize = (img) => { const w = img.getBoundingClientRect().width; if (w > 0) img.sizes = Math.round(w) + 'px'; };
  const ro = 'ResizeObserver' in window ? new ResizeObserver((es) => es.forEach((e) => autosize(e.target))) : null;
  window.elAutoSizes = function (root) {
    (root || document).querySelectorAll('img[data-el-autosize]:not([data-el-sized])').forEach((img) => {
      img.dataset.elSized = '1'; autosize(img); ro && ro.observe(img);
    });
  };
  new MutationObserver(() => window.elAutoSizes()).observe(document.documentElement, { childList: true, subtree: true });

  const ready = () => {
    window.elAutoSizes();
    window.elInitSwatches();
    document.querySelectorAll('[data-el-swatch-hover]').forEach((root) => window.elInitSwatchHover(root));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
